import {
	lifHttp as http,
	lifUser as httpUser,
	vcpodeHttp as httpVcpodeUser,
} from "@/http/index.js";
import { serialize } from "./utils";

const login = (payload) => httpUser.post(`auth/login`, { ...payload });
const forgot = (payload) => httpUser.post(`auth/forgot`, { ...payload });
const reset = (payload) => httpUser.put(`auth/forgot`, { ...payload });
const list = (payload) =>
	httpUser.get(`auth/users?limit=${payload.limit || 10}`, { ...payload });
const disable = (payload) => httpUser.post(`auth/disable`, { ...payload });
const enable = (payload) => httpUser.post(`auth/enable`, { ...payload });
const create = (payload) => httpUser.post(`auth/signup`, { ...payload });
const forgotPassword = (payload) =>
	httpUser.post(`auth/forgot`, { ...payload });
const newPassword = (payload) => httpUser.put(`user/password`, { ...payload });
const checkRmsStatus = (payload) =>
	httpVcpodeUser.post(`rms/beneficiario/consulta`, { ...payload });
const reprocessRms = (data = {}) => {
	const params = serialize(data);
	return httpVcpodeUser.post(`rms/beneficiario/reprocess${params}`);
};
const resetPassword = (userId, data) => http.put(`admin/change-password/${userId}`, data);

export const users = {
	login,
	forgot,
	reset,
	list,
	disable,
	enable,
	create,
	forgotPassword,
	newPassword,
	checkRmsStatus,
	reprocessRms,
	resetPassword
};
